import { } from '@/api/requests';
import router from '../../router';

const state = {
  user: {},
  token: '',
  selectedUser: {},
  viewUserDetails: false,
  userProPrompt: false,
};

const mutations = {
  updateAttribute(state, payload) {
    state[payload.type] = payload.value;
  },

  setUserData(state, payload) {
    state.user = payload['user'];
    state.token = payload['access_token'];
  },
  
  removeUserData(state) {
    state.user = {};
    state.token = '';
  },
  
  setSelectedUser(state, user) {
    state.selectedUser = user;
    state.viewUserDetails = true;
  },

  clearSelectedUser(state) {
    state.selectedUser = {};
    state.viewUserDetails = false;
  },

  showUserProPrompt(state) {
    state.userProPrompt = true;
  },

  closeUserProPrompt(state) {
    state.userProPrompt = false;
  },

};

const actions = {
  userClicked(context, user) {
    context.commit('setSelectedUser', user);
  },

  userDetailsClosed(context) {
    context.commit('clearSelectedUser');
  },

  logout(context) {
    context.commit('removeUserData');
    localStorage.clear();
    router.push('/');
  },

  showProPrompt(context) {
    context.commit('showUserProPrompt');
  },

  closeProPrompt(context) {
    context.commit('closeUserProPrompt');
  },
};

const getters = {

};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};